"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.register = exports.sendPasswordResetInstructions = exports.logout = exports.authenticate = void 0;
function authenticate(client, opts) {
    return client.post('authenticate', {
        email: opts.email,
        password: opts.password
    });
}
exports.authenticate = authenticate;
function logout(client, opts) {
    return client.post('logout', opts.authToken);
}
exports.logout = logout;
function sendPasswordResetInstructions(client, opts) {
    return client.post('send_password_reset_instructions', { email: opts.email });
}
exports.sendPasswordResetInstructions = sendPasswordResetInstructions;
function register(client, opts) {
    return client.post('register', { registration: opts.registration });
}
exports.register = register;
